import { createOptionsFrom } from "@/lib/common/Option";

export const EvListSortLabels = {
	HighestEstimatedValue: "Highest Estimated Value",
	LowestEstimatedValue: "Lowest Estimated Value",
	HighestMarketPrice: "Highest Market Price",
	LowestMarketPrice: "Lowest Market Price",
	MarketPriceDeltaPositive: "Market Price Delta (Positive)",
	MarketPriceDeltaNegative: "Market Price Delta (Negative)",
	NewestReleaseDate: "Newest Release Date",
	OldestReleaseDate: "Oldest Release Date"
} as const;

export type EvListSort = keyof typeof EvListSortLabels;

export const EvListSortOptions = createOptionsFrom(EvListSortLabels);
